<div [formGroup]="parentForm()" class="col-span-1">
  <siat-upload-file
    [label]="label() || 'Nessuna label inserita'"
    [placeholder]="placeholder() || 'Caricamento file'"
    formControlName="value"
    [previewResolver]="resolvePreview"
    (onDelete)="onDeleteFile($event, parentForm())"
  >
  </siat-upload-file>
</div>
<div class="col-span-1 pl-4 text-left">
  <button
    matButton="filled"
    matTooltip="Visualizza su Moniser"
    [disabled]="!parentForm().get('value')?.value"
  >
    Vai a Moniser
    <mat-icon>open_in_new</mat-icon>
  </button>
</div>
